export default __webpack_public_path__ + "static/media/switch@2x.0671e2a7.png";